module.exports = __webpack_public_path__ + "static/media/IsometricPressMale.1dcba590.svg";